// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.hidden {
  display: none;
}

.header-container {
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  height: 64px;
  color: #0669B3;
  margin-left: 1%;
  margin-right: 1%;
  margin-top: 7px;
  padding: 3px;
  padding-bottom: 10px;
}
.header-container .header-dcsd-icon {
  margin-left: 3px;
  margin-top: 5px;
}
.header-container .header-left {
  display: flex;
  justify-content: space-between;
}
.header-container .header-left .header-name-container {
  height: 70px;
  display: flex;
  align-items: center;
  padding-top: 10px;
  margin-left: 20px;
}
.header-container .header-right {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
}
.header-container .header-right .color-override {
  background: #0669B3 !important;
}
.header-container .header-right .nav-button-container {
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.header-container .header-right .nav-button-container .nav-button-links {
  border-radius: 4px;
  padding: 0 15px 0 15px;
  text-transform: lowercase;
}
.header-container .header-right span {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.header-container .header-right span .nav-button-icon {
  padding-left: 10px;
}
.header-container .header-right .nav-button-text {
  color: white;
  font-size: 0.9em;
}

.mobile-hamburger {
  display: none;
}

@media only screen and (max-width: 900px) {
  .mobile-hamburger {
    display: block;
    margin: 5px 25px 0 0;
  }
  .mobile-menu-links a {
    color: #19608f;
    font-size: 0.85em;
    font-weight: 500;
    margin-left: 10px;
  }
  .nav-button-container {
    display: none !important;
  }
  .header-container {
    display: flex;
    justify-content: space-between;
  }
  .header-name-container h5 {
    margin: 0 2.5rem 0 0;
    font-size: 1em;
  }
  .mobile-menu-bold {
    font-weight: bold;
  }
  .helpful-links-dropdown div a {
    text-decoration: none;
  }
  .mobile-list-hamburger {
    margin-left: 16px;
  }
  .mobile-dropdown-icon {
    padding-right: 10px;
  }
  Button a {
    color: #19608f;
    padding-left: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Header.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,aAAA;AAKJ;;AAFA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,cDmBS;EClBT,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AAKJ;AAHI;EACI,gBAAA;EACA,eAAA;AAKR;AAHI;EACI,aAAA;EACA,8BAAA;AAKR;AAJQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAMZ;AAHI;EACI,aAAA;EACA,8BAAA;EACA,eAAA;AAKR;AAHQ;EACI,8BAAA;AAKZ;AAHQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAKZ;AAHY;EACI,kBAAA;EACA,sBAAA;EACA,yBAAA;AAKhB;AAFQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAIZ;AAFY;EACI,kBAAA;AAIhB;AADQ;EACI,YAAA;EACA,gBAAA;AAGZ;;AAGA;EACI,aAAA;AAAJ;;AAQA;EACI;IACI,cAAA;IACA,oBAAA;EALN;EAQE;IACI,cDlFE;ICmFF,iBAAA;IACA,gBAAA;IACA,iBAAA;EANN;EASE;IACI,wBAAA;EAPN;EAUE;IACI,aAAA;IACA,8BAAA;EARN;EAWE;IACI,oBAAA;IACA,cAAA;EATN;EAYE;IACI,iBAAA;EAVN;EAaE;IACI,qBAAA;EAXN;EAcE;IACI,iBAAA;EAZN;EAeE;IACI,mBAAA;EAbN;EAgBE;IACI,cDvHE;ICwHF,iBAAA;EAdN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Guardian Dashboard colors\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n\n$error: #CE3525;\n$error-dk: #aa3333;\n$error-hover: #cf4635;\n$hover-white: #E0E0E0;\n$light-background: #EFEFEF;\n\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #4a8319;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$icon-blue: #4DD9FF;\n","@import \"../styles/global/Colors\";\n\n.hidden {\n    display: none;\n}\n\n.header-container {\n    background: white;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 100%;\n    height: 64px;\n    color: $pearl-blue;\n    margin-left: 1%;\n    margin-right: 1%;\n    margin-top: 7px;\n    padding: 3px;\n    padding-bottom: 10px;\n\n    & .header-dcsd-icon {\n        margin-left: 3px;\n        margin-top: 5px;;\n    }\n    .header-left {\n        display: flex;\n        justify-content: space-between;\n        .header-name-container {\n            height: 70px;\n            display: flex;\n            align-items: center;\n            padding-top: 10px;\n            margin-left: 20px;\n        }\n    }\n    .header-right {\n        display: flex;\n        justify-content: space-between;\n        font-size: 1rem;\n\n        & .color-override {\n            background:$pearl-blue !important;\n        }\n        .nav-button-container {\n            height: 70px;\n            display: flex;\n            align-items: center;\n            padding: 0 20px;\n\n            & .nav-button-links {\n                border-radius: 4px;\n                padding: 0 15px 0 15px;\n                text-transform: lowercase;\n            }\n        }\n        span {\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n            align-items: center;\n\n            & .nav-button-icon {\n                padding-left: 10px;\n            }\n        }\n        .nav-button-text {\n            color: white;\n            font-size: .9em;\n        }\n\n    } // end of .header-right\n} // end of .header-container\n\n.mobile-hamburger {\n    display: none;\n}\n\n\n//////////////////////////////////////////////////////////////////////////////////////////////\n// MEDIA QUERIES //\n//////////////////////////////////////////////////////////////////////////////////////////////\n\n@media only screen and (max-width: 900px){\n    .mobile-hamburger {\n        display: block;\n        margin: 5px 25px 0 0;\n    }\n\n    .mobile-menu-links a {\n        color: $dk-blue;\n        font-size: .85em;\n        font-weight: 500;\n        margin-left: 10px;\n    }\n\n    .nav-button-container {\n        display: none !important;\n    }\n\n    .header-container {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .header-name-container h5 {\n        margin: 0 2.5rem 0 0;\n        font-size: 1em;\n    }\n\n    .mobile-menu-bold {\n        font-weight: bold;\n    }\n\n    .helpful-links-dropdown div a {\n        text-decoration: none;\n    }\n\n    .mobile-list-hamburger {\n        margin-left: 16px;\n    }\n\n    .mobile-dropdown-icon {\n        padding-right: 10px;\n    }\n\n    Button a {\n        color: $dk-blue;\n        padding-left: 5px;\n    }\n\n};\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
